import LoginId               from "../../../domain/authentication/LoginId";
import FirstName             from "../../../domain/fundamentals/name/FirstName";
import FirstNameKana         from "../../../domain/fundamentals/name/FirstNameKana";
import LastName              from "../../../domain/fundamentals/name/LastName";
import LastNameKana          from "../../../domain/fundamentals/name/LastNameKana";
import Name                  from "../../../domain/fundamentals/name/Name";
import Staff                 from "../../../domain/staff/Staff";
import StaffId               from "../../../domain/staff/StaffId";
import StaffMemo             from "../../../domain/staff/StaffMemo";
import { StaffResponseType } from "../../api/staff/StaffResponseType";
import { toGenderType }      from "../fundamentals";

export const toStaff = (source: StaffResponseType): Staff => new Staff(
  new StaffId(source.id),
  new Name(
    new LastName(source.last_name),
    new FirstName(source.first_name),
    new LastNameKana(source.last_name_kana),
    new FirstNameKana(source.first_name_kana),
  ),
  toGenderType(source.gender),
  new StaffMemo(source.memo),
  new LoginId(source.login_id),
);
